import { Progress } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CollapseHeaderWrapper, TitleAndTagWrapper } from '../../../components/styled'
import { BoardCounter } from 'views/components/Board/BoardCounter'

type Props = {
  counter: number | undefined
  progress: Progress
}

export const TripsHeader: FC<Props> = ({ counter, progress }) => {
  const { t } = useTranslation('logisticBids')

  return (
    <CollapseHeaderWrapper>
      <TitleAndTagWrapper>
        <div>{t('board_columns.title.trips')}</div>
        <BoardCounter counter={counter} progress={progress} />
      </TitleAndTagWrapper>
    </CollapseHeaderWrapper>
  )
}
